export default ['barcelona', 'percent'];



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/zone/tourist-tax-types.js